<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col>
          <h1>Rappi Tiendas</h1>
        </b-col>
        <b-col cols="auto">
          <b-button variant="warning" size="sm" class="my-3" @click="showBulkMenuModal">Enviar  Múltiples Menús</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Buscar tienda:">
            <b-form-input v-model="search" placeholder="Buscar por nombre..." debounce="300"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page=1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col xs="12" sm="6" md="4" lg="3" xl="3" v-for="sucursal in filteredStores" v-bind:key="sucursal.id">
          <b-card class="mb-3">
            <b-card-body class="p-1">
              <h6 class="card-title mb-2">{{ sucursal.name }}</h6>
              <p class="card-text small mb-2">
                <strong>ID:</strong> {{ sucursal.id }}<br>
                <strong>Menu:</strong> {{ sucursal.menu || 'N/A' }}
              </p>
              <div class="mb-2">
                <b-badge v-if="sucursal.id==null || sucursal.id<=0" variant="warning" class="me-1">No Configurado</b-badge>
                <b-badge v-else variant="success" class="me-1">Configurado</b-badge>
                <b-badge v-if="sucursal.parent_id == null" variant="success">DADDY</b-badge>
                <b-badge v-else variant="primary">{{ sucursal.parent_id }}</b-badge>
              </div>
              <div class="d-flex flex-column gap-1">
                <b-button size="sm" :disabled="sucursal.parent_id != null" variant="success" block
                  @click="sendRappiMenu(sucursal.id)">Enviar Menu</b-button>
                <b-button size="sm" variant="outline-info" block @click="showRappiDetails(sucursal)">Detalles</b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      
      <!-- Rappi Details Modal -->
      <b-modal id="rappi-details-modal" :title="'Detalles Rappi - ' + selectedStore.name" size="lg" @hidden="resetModalData">
        <div v-if="selectedStore.id && selectedStore.id > 0">
          <b-row class="mb-3">
            <b-col>
              <h5>Información General</h5>
              <p>
                ID Rappi: {{ selectedStore.id }}<br>
                Menu Rappi: {{ selectedStore.rappi_menu_id }}<br>
                Menu Status: {{ rappiMenuStatus }}<br>
                Url web: <a :href="'https://www.rappi.com.mx/restaurantes/'+selectedStore.rappi_id" target="_blank">
                  {{ 'https://www.rappi.com.mx/restaurantes/'+selectedStore.rappi_id }}
                </a>
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col>
              <h5>Código Check In</h5>
              <p>
                Código: {{ rappiCheckInCode.code }}<br>
                Código Vence: {{ rappiCheckInCode.expired_at }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button variant="primary" @click="refreshRappiInfo(selectedStore.id)">Actualizar Info</b-button>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <b-alert show variant="warning">Esta tienda no tiene configuración de Rappi</b-alert>
        </div>
      </b-modal>
      
      <!-- Bulk Menu Send Modal -->
      <b-modal id="bulk-menu-modal" title="Enviar Menús Múltiples" size="lg" @ok="sendBulkMenus">
        <b-form-group label="Seleccionar tiendas:">
          <div style="max-height: 300px; overflow-y: auto;">
            <b-form-checkbox-group v-model="selectedStores" :options="storeOptions" stacked></b-form-checkbox-group>
          </div>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="selectAll" @change="toggleSelectAll">Seleccionar todas</b-form-checkbox>
        </b-form-group>
        <p><strong>{{ selectedStores.length }}</strong> tiendas seleccionadas</p>
      </b-modal>
      <!-- <b-row>
        <b-col>
          <b-table small
            stacked="sm"
            :filter="search"
            striped
            hover
            :fields="tableFields"
            :items="storesTable"
            responsive="md"
            :per-page="byPage"
            :current-page="page"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

<template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="success" @click="$router.push('/sucursal/' + data.item.id)"
                  >Ver Más +</b-button
                >
                
              </b-button-group>
            </template>
<template #cell(group)="data">
              {{searchGroup(data.item.group).name}}
            </template>
<template #cell(subgroup)="data">
              {{searchSubgroup(data.item.subgroup).name}}
            </template>
<template #cell(status)="data">
                <b-badge pill v-if="data.item.status" variant="success">ACTIVO</b-badge>
                <b-badge pill v-else variant="danger">INACTIVO</b-badge>
            </template>
<template #cell(image)="data">
              <img style="max-width: 8vh;" :src="axios.defaults.baseURL + '/' +data.item.image">
            </template>
</b-table>
</b-col>
</b-row>
<b-row>
  <b-col>
    <b-pagination v-model="page" :total-rows="storesTable.length" :per-page="byPage"
      aria-controls="my-table"></b-pagination>
  </b-col>
</b-row> -->
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
export default {
  name: "RappiStores",
  components: { Nav },
  data() {
    return {
      sucursalesDesconectadas: null,
      sucursalesEnLinea: null,
      byPage: 20,
      page: 1,
      storesTable: [],
      search: "",
      rappiMenus: [],
      rappiMenusOptions: [],
      selectedStore: {},
      rappiMenuStatus: "",
      rappiCheckInCode: {
        code: "",
        created_at: "",
        expired_at: "",
        updated_at: ""
      },
      selectedStores: [],
      selectAll: false,
      storeOptions: [],
      tableFields: [
        { key: "id", label: "ID", sortable: true, sortDirection: "desc", class: "align-middle" },
        { key: "nombre", label: "Nombre", sortable: true, class: "align-middle" },
        { key: "version", label: "Version", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "buttons", label: "" },
      ],
    };
  },
  activated() {
  },
  created() {
    this.getAllrappiMenus()

  },
  computed: {
    filteredStores() {
      if (!this.search) return this.storesTable;
      return this.storesTable.filter(store => 
        store.name.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    getAllrappiMenus() {
      let that = this;
      console.log("Getting Rappi menus")
      axios
        .get("/rappi/menus")
        .then(function (response) {
          that.rappiMenus = response.data;
          console.log(response.data)
          let persfil = response.data
            .map((pers) => {
              return { id: pers.id, label: pers.name };
            });
          let persfils = [{ id: undefined, label: "" }]
          persfils.push(...persfil)
          that.rappiMenusOptions = persfils;
          that.getAllRappiStores();

        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    cleanNewSucursal() {
      this.newuser.name = "";
      this.newuser.password = "";
      this.newuser.email = "test@mail.com";
      this.newuser.username = "";
      this.newuser.cellphone = "5511223344";
    },
    sendRappiMenu(id) {
      let that = this
      axios.post("/rappi/store/" + id + "/sendmenu")
        .then(function (data) {
          console.log(data)
          that.makeToast(
            "Exito",
            "Menu enviado",
            "success"
          );
        })
        .catch(function (err) {
          console.log(err);
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    newSucursal(event) {
      event.preventDefault();
      let that = this;
      axios
        .post("/user", this.newuser)
        .then(function (data) {
          that.makeToast(
            "Exito",
            data.response.username + " creado",
            "success"
          );
          that.cleanNewSucursal();
          that.getAllRappiStores();
          that.search = data.response.username;
        })
        .catch(function (err) {
          console.log(err.request.response);
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getAllRappiStores() {
      let that = this;
      axios
        .get("/rappi/stores")
        .then(function (response) {
          that.storesTable = response.data.sort((a, b) => { return a.name.localeCompare(b.name) }).map(function (str) {
            let init = str
            let menuText = ""
            that.rappiMenusOptions.find(function (e) {
              if (e.id == init.rappi_menu_id) {
                menuText = e.label
                return true
              }
              return false
            })
            init.menu = menuText
            return init
          })
          that.storeOptions = that.storesTable
            .filter(store => store.parent_id == null && store.id > 0)
            .map(store => ({ value: store.id, text: store.name }));
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    showRappiDetails(store) {
      this.selectedStore = store;
      if (store.id && store.id > 0) {
        this.getRappiInfo(store.id);
        this.getRappiMenuStatus(store.id);
      }
      this.$bvModal.show('rappi-details-modal');
    },
    getRappiInfo(storeId) {
      let that = this;
      axios
        .post("/rappi/store/" + storeId + "/checkincode")
        .then(function (response) {
          that.rappiCheckInCode = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getRappiMenuStatus(storeId) {
      let that = this;
      axios
        .get("/rappi/store/" + storeId + "/status")
        .then(function (response) {
          that.rappiMenuStatus = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    refreshRappiInfo(storeId) {
      console.log("refresh info "+storeId)
      this.getRappiInfo(storeId);
      this.getRappiMenuStatus(storeId);
      this.makeToast("Info", "Información actualizada", "info");
    },
    showBulkMenuModal() {
      this.selectedStores = [];
      this.selectAll = false;
      this.$bvModal.show('bulk-menu-modal');
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedStores = this.storeOptions.map(option => option.value);
      } else {
        this.selectedStores = [];
      }
    },
    async sendBulkMenus() {
      if (this.selectedStores.length === 0) {
        this.makeToast("Advertencia", "Selecciona al menos una tienda", "warning");
        return;
      }
      
      let successCount = 0;
      let errorCount = 0;
      
      for (let storeId of this.selectedStores) {
        try {
          await axios.post("/rappi/store/" + storeId + "/sendmenu");
          successCount++;
          const store = this.storesTable.find(s => s.id === storeId);
          this.makeToast("Exito", `Menu enviado: ${store ? store.name : storeId}`, "success");
        } catch (err) {
          errorCount++;
          const store = this.storesTable.find(s => s.id === storeId);
          this.makeToast("Error", `Error en: ${store ? store.name : storeId} ${err.request.response}`, "danger");
        }
      }
      
      this.makeToast("Completado", `Proceso terminado. Exitosos: ${successCount}, Errores: ${errorCount}`, "info");
    },
    resetModalData() {
      this.selectedStore = {};
      this.rappiMenuStatus = "";
      this.rappiCheckInCode = {
        code: "",
        created_at: "",
        expired_at: "",
        updated_at: ""
      };
    },
    makeToast(title, content, variant) {
      console.log("MAKING TOAST")
      this.$bvModal.msgBoxOk(content, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    },
  },
};
</script>
